import { Layout, Menu, Breadcrumb, Button, Typography, Space } from "antd";
import { useState, useEffect } from "react";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  FundViewOutlined,
} from "@ant-design/icons";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getSelfUser, logoutUser } from "../actions/user";
import { APP_VERSION } from "../config";
import classNames from "../styles/styles.module.css";
import logo from "../assets/images/logo.webp";
import Stations from "./Stations/Stations";
import Vehicles from "./Vehicles/Vehicles";
import Transactions from "./Transactions/Transactions";
import Rides from "./Rides/Rides";
import Users from "./Users/Users";
import Dashboard from "./Dashboard";
import Vehicle from "./Vehicles/Vehicle";
import Settings from "./Settings/Settings";
import Campuses from "./Campuses/Campuses";
import VehicleRoutes from "./VehicleRoutes/VehicleRoutes";
import Subscriptions from "./Subscriptions/Subscriptions";
import VehiclesData from "./VehiclesData/VehiclesData";
import UserPlans from "./UserPlans/UserPlans";
import RideRequets from "./RideRequests/RideRequets";
import Drivers from "./Drivers/Drivers";
import Rewards from "./Rewards/Rewards";

const { Header, Sider, Content } = Layout;

function PrivatePages() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/");
  };

  useEffect(() => {
    dispatch(getSelfUser());
  }, []);

  const componentLists = {
    Dashboard: {
      tabName: "Dashboard",
      tabIcon: (
        <img src={"/assets/imgs/stats.png"} style={{ width: 25, height: 25 }} />
      ),
      path: "/",
      component: <Dashboard />,
      subPaths: [],
    },
    "Subscription Plans": {
      tabName: "Subscription Plans",
      tabIcon: (
        <img
          src={"/assets/imgs/station.png"}
          style={{ width: 25, height: 25 }}
        />
      ),
      path: "/plans",
      component: <Subscriptions />,
      subPaths: [],
    },
    "User Plans": {
      tabName: "User Plans",
      tabIcon: (
        <img src={"/assets/imgs/cash.png"} style={{ width: 25, height: 25 }} />
      ),
      path: "/user-plans",
      component: <UserPlans />,
      subPaths: [],
    },
    Campuses: {
      tabName: "Campuses",
      tabIcon: (
        <img
          src={"/assets/imgs/station.png"}
          style={{ width: 25, height: 25 }}
        />
      ),
      path: "/campuses",
      component: <Campuses />,
      subPaths: [],
    },
    Rewards: {
      tabName: "Referrals and Rewards",
      path: "/rewards",
      component: <Rewards />,
      subPaths: [],
    },
    "Dock Stations": {
      tabName: "Dock Stations",
      tabIcon: (
        <img
          src={"/assets/imgs/station.png"}
          style={{ width: 25, height: 25 }}
        />
      ),
      path: "/stations",
      component: <Stations />,
      subPaths: [],
    },
    Vehicles: {
      tabName: "Vehicles",
      tabIcon: (
        <img
          src={"/assets/imgs/bicycle.png"}
          style={{ width: 25, height: 25 }}
        />
      ),
      path: "/vehicles",
      component: <Vehicles />,
      subPaths: [{ path: ":id", component: <Vehicle /> }],
    },
    VehiclesData: {
      tabName: "Vehicles Data",
      tabIcon: (
        <img
          src={"/assets/imgs/bicycle.png"}
          style={{ width: 25, height: 25 }}
        />
      ),
      path: "/vehicles-data",
      component: <VehiclesData />,
      subPaths: [],
    },
    "Vehicle Routes": {
      tabName: "Vehicle Routes",
      tabIcon: (
        <img
          src={"/assets/imgs/distance.png"}
          style={{ width: 25, height: 25 }}
        />
      ),
      path: "/vehicle-routes",
      component: <VehicleRoutes />,
      subPaths: [],
    },
    "Ride Requests": {
      tabName: "Ride Requests",
      tabIcon: (
        <img src={"/assets/imgs/ride.png"} style={{ width: 25, height: 25 }} />
      ),
      path: "/ride-requests",
      component: <RideRequets />,
      subPaths: [],
    },
    Rides: {
      tabName: "Rides",
      tabIcon: (
        <img src={"/assets/imgs/ride.png"} style={{ width: 25, height: 25 }} />
      ),
      path: "/rides",
      component: <Rides />,
      subPaths: [],
    },
    Transactions: {
      tabName: "Transactions",
      tabIcon: (
        <img
          src={"/assets/imgs/wallet.png"}
          style={{ width: 25, height: 25 }}
        />
      ),
      path: "/transactions",
      component: <Transactions />,
      subPaths: [],
    },
    Users: {
      tabName: "Users",
      tabIcon: (
        <img src={"/assets/imgs/users.png"} style={{ width: 25, height: 25 }} />
      ),
      path: "/users",
      component: <Users />,
      subPaths: [],
    },
    Drivers: {
      tabName: "Drivers",
      tabIcon: (
        <img src={"/assets/imgs/users.png"} style={{ width: 25, height: 25 }} />
      ),
      path: "/drivers",
      component: <Drivers />,
      subPaths: [],
    },
    Settings: {
      tabName: "Settings",
      tabIcon: (
        <img
          src={"/assets/imgs/settings.png"}
          style={{ width: 25, height: 25 }}
        />
      ),
      path: "/settings",
      component: <Settings />,
      subPaths: [],
    },
  };

  const Tabs = [
    {
      component: "Dashboard",
    },
    {
      component: "Campuses",
    },
    {
      component: "Dock Stations",
    },
    {
      component: "Vehicles",
    },
    {
      component: "VehiclesData",
    },
    {
      component: "Vehicle Routes",
    },
    {
      component: "Ride Requests",
    },
    {
      component: "Rides",
    },
    {
      component: "Transactions",
    },
    {
      component: "Subscription Plans",
    },
    { component: "Rewards" },
    {
      component: "Users",
    },
    {
      component: "Drivers",
    },
    {
      component: "User Plans",
    },
    {
      component: "Settings",
    },
  ];

  const mobileTabs = [
    {
      component: "Dashboard",
    },
    {
      component: "Campuses",
    },
    {
      component: "Dock Stations",
    },
    {
      component: "Vehicles",
    },
    {
      component: "VehiclesData",
    },
    {
      component: "Vehicle Routes",
    },
    {
      component: "Ride Requests",
    },
    {
      component: "Rides",
    },
    {
      component: "Transactions",
    },
    {
      component: "Subscription Plans",
    },
    { component: "Rewards" },

    {
      component: "Users",
    },
    {
      component: "Drivers",
    },
    {
      component: "User Plans",
    },
    {
      component: "Settings",
    },
  ];

  const renderTabButton = ({ component }) => {
    let { tabName, tabIcon, path } = componentLists[component];
    return (
      <Menu.Item
        key={path}
        onClick={() => {
          navigate(path);
        }}
        icon={tabIcon}
      >
        {tabName}
      </Menu.Item>
    );
  };

  const renderRoute = ({ path, component, subPaths = [] }) => {
    return (
      <Route key={path} path={path}>
        <Route index element={component} />
        {subPaths?.map((path) => renderRoute(path))}
      </Route>
    );
  };

  return (
    <Layout style={{ flex: 1, height: "100%" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className={classNames.layoutSlider}
      >
        <div
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            marginBottom: 10,
            marginTop: 10,
          }}
        >
          <img src={logo} style={{ width: "90%" }} />
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[window.location.pathname.split("/", 2).join("/")]}
        >
          {Tabs.map((tab) => renderTabButton(tab))}
        </Menu>

        <div style={{ position: "absolute", bottom: 10, right: 10 }}>
          <Typography.Text style={{ color: "#fff" }} strong>
            {"v" + APP_VERSION}
          </Typography.Text>
        </div>
      </Sider>
      {collapsed ? (
        <div
          style={{ position: "absolute", zIndex: 99, top: 60 }}
          className={classNames.mobileTabs}
        >
          <Menu
            style={{
              width: 250,
              padding: "25px 30px",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            }}
            selectedKeys={[window.location.pathname.split("/", 2).join("/")]}
          >
            {mobileTabs.map((tab) => renderTabButton(tab))}
          </Menu>
        </div>
      ) : null}
      <Layout className="site-layout">
        <Header
          className="site-layout-background flex"
          style={{
            padding: "0px 15px",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {collapsed ? (
              <MenuUnfoldOutlined className="trigger" onClick={toggle} />
            ) : (
              <MenuFoldOutlined className="trigger" onClick={toggle} />
            )}
            <Breadcrumb>
              {window.location.pathname.split("/").map((path, index) => (
                <Breadcrumb.Item key={index + "b"}>
                  {path.toUpperCase()}
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
          </div>
          <Space style={{ display: "flex", gap: 25 }}>
            <Button onClick={handleLogout}>Logout</Button>
          </Space>
        </Header>

        <Content
          className="site-layout-background"
          style={{
            margin: "24px 16px",
            padding: "24px 16px",
            // minHeight: 280,
          }}
        >
          <Routes>
            <Route
              path="/login"
              caseSensitive
              element={
                <Navigate to={componentLists[Tabs[0].component].path} replace />
              }
            />
            <Route path="/" caseSensitive />
            {Tabs.map((tab) => renderRoute(componentLists[tab.component]))}
            <Route path="*" element={<div>404</div>} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

export default PrivatePages;
